import React from 'react';
import { useReveal } from '../../hooks/useReveal';

const TIMELINE = [
  {
    date: 'Jul 2025 – Present',
    title: 'Sr Manager, Machine Learning Science',
    org: 'Cotality',
    desc:
      'Leading machine learning science initiatives, driving strategy and execution of AI/ML solutions across the organization.',
  },
  {
    date: 'Jul 2022 – Jul 2025',
    title: 'Senior Machine Learning Engineer',
    org: 'CoreLogic',
    desc:
      'Built and deployed production-grade computer vision and deep learning models for the mortgage and property intelligence industry. Applied transformer architectures and advanced techniques including CNNs, ResNets, and U-Nets at scale.',
  },
  {
    date: 'Oct 2021 – Jul 2022',
    title: 'Data Scientist',
    org: 'CoreLogic',
    desc:
      'Developed predictive models and data pipelines for property and mortgage analytics. Focused on machine learning model development, data mining, and translating business requirements into data-driven solutions.',
  },
  {
    date: 'Jul 2019 – Oct 2021',
    title: 'Professional Software Engineer',
    org: 'CoreLogic | FNC — Integrations Team',
    desc:
      'Designed and developed a centralized payment service enabling seamless communication between multiple applications and external clients. Built microservice integrations using .NET Core and Java bridging internal systems with third-party APIs.',
  },
  {
    date: 'Aug 2017 – May 2019',
    title: "Master's in Engineering Science",
    org: 'University of Mississippi · Computer Science Emphasis · GPA 4.0',
    desc:
      'Focused on Machine Learning research — specifically how pretrained CNN weights improve performance on downstream vision tasks. Graduated May 2019.',
  },
  {
    date: 'Aug 2013 – May 2017',
    title: 'B.S. in Computer Science',
    org: 'University of Mississippi',
    desc:
      'Coursework in Artificial Intelligence, Digital Image Processing, Natural Language Processing, and Cloud Computing. Graduated May 2017.',
  },
];

export default function Experience() {
  const ref = useReveal(0.05);

  return (
    <section className="section section--alt" id="experience" ref={ref}>
      <div className="container">
        <div className="section__header">
          <span className="label reveal">Experience &amp; Education</span>
          <h2 className="section-title reveal reveal-delay-1">My Journey</h2>
          <div className="section-divider reveal reveal-delay-2" aria-hidden="true" />
        </div>

        <div className="timeline">
          {TIMELINE.map((item, i) => (
            <article
              key={i}
              className={`timeline-item reveal reveal-delay-${Math.min(i + 2, 6)}`}
            >
              <div className="timeline-dot" aria-hidden="true" />
              <p className="timeline-date">{item.date}</p>
              <h3 className="timeline-title">{item.title}</h3>
              <span className="timeline-org">{item.org}</span>
              <p className="timeline-desc">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
